import { render, staticRenderFns } from "./WhatsappIcon.vue?vue&type=template&id=77a859f8&scoped=true&"
import script from "./WhatsappIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WhatsappIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a859f8",
  null
  
)

export default component.exports